import { render, staticRenderFns } from "./article-true-costs.vue?vue&type=template&id=edbe8a80&scoped=true&"
import script from "./article-true-costs.vue?vue&type=script&lang=ts&"
export * from "./article-true-costs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbe8a80",
  null
  
)

export default component.exports